import { createSlice } from '@reduxjs/toolkit';
import { widgetApi } from '../widget/widget.api';
import { AppointmentReducerState } from './types';

const getInitialState = (): AppointmentReducerState => ({
  appointments: [],
});

const appointmentSlice = createSlice({
  name: 'appointmentReducer',
  initialState: getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(widgetApi.endpoints.getWidgetDataByAppointmentGroups.matchFulfilled, (state, { payload }) => {
      state.appointments = payload.appointments;
    });
  },
});

const { reducer } = appointmentSlice;

export default reducer;
